// utils/rtk-query-helpers.ts

import { getSelectedProjectShortName } from '../../apis/apiHeader';

export const serializeQueryArgsWithProjectShortName = (
  endpointName: string,
  queryArgs: unknown,
): string => {
  const projectShortName = getSelectedProjectShortName();
  return serializeQueryArgsCustom(endpointName, queryArgs, projectShortName);
};

export const serializeQueryArgsCustom = (
  endpointName: string,
  queryArgs: unknown,
  projectShortName?: string,
): string => {
  let result = endpointName;

  if (projectShortName) {
    result = `${result}-${projectShortName}`;
  }

  if (queryArgs) {
    const argsString =
      typeof queryArgs === 'object' ? JSON.stringify(queryArgs) : String(queryArgs);
    result = `${result}-args(${argsString})`;
  }

  return result;
};
